module.exports = __webpack_public_path__ + "static/img/4-1-2.d9bf15d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-1-2.png
// module id = BMGr
// module chunks = 12